import * as styles from "./VisuallyHidden.module.css"

interface Props {
	children: React.ReactNode
}

export const VisuallyHidden = (props: Props) => {
	return <span className={styles.container} {...props} />
}
